import styled from 'styled-components'

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.secondary};
  border-radius: 12px;
  overflow: hidden;
`

export const HeaderButton = styled.button`
  width: 100%;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  cursor: pointer;
`

export const Label = styled.span`
  ${({ theme }) => theme.fonts.infoLG};
  color: ${({ theme }) => theme.colors.neutralL5};
  text-transform: uppercase;
`

export const CheckboxWrapper = styled.span`
  display: inline-flex;
  align-items: center;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.secondaryL2};
`
